module.exports = __webpack_public_path__ + "img/Group2818.08b0dd15.png";